import { ApplyDiscount } from "@/types/gtm/QuoteReviewEvent";
import { QuoteData } from "@/types/quote/quote-data";

function getVoucherCode(
  paymentDetails: QuoteData["attributes"]["paymentDetails"],
  voucherCode: string
) {
  const discounts = paymentDetails?.discounts;
  const vCode = discounts?.voucher?.find(
    (voucher) => voucher.code === voucherCode
  )?.code;

  return vCode;
}

function quoteReviewDiscountDataMap(
  attributes: QuoteData["attributes"],
  voucherCode: string,
  isDataMap?: boolean,
  event?: string,
  eventName?: string
) {
  const { paymentDetails } = attributes;

  if (paymentDetails && isDataMap) {
    return {
      event: event ?? "voucher",
      event_name: eventName ?? "apply_voucher",
      voucher_code: getVoucherCode(paymentDetails, voucherCode),
    } as unknown as ApplyDiscount;
  }
  return {} as ApplyDiscount;
}

export { quoteReviewDiscountDataMap };
